import React from 'react'
import styled from 'styled-components'
import { Sling as Hamburger } from 'hamburger-react'
import { MainMenu } from './MainMenu'
import { size } from './platform'

export const ToggleMenu = styled((props: any) => (
  <label htmlFor="tm" {...props}>
    <Hamburger
      color="#35b3a9"
      onToggle={props.onChange}
      size={18}
      toggled={props.value}
    />
  </label>
))`
  order: 5;
  @media only screen and (min-width: 1024px) {
    display: none;
  }
`

export const ToggleMenuCheckbox = styled((props: any) => (
  <input id="tm" type="checkbox" {...props} />
))`
  order: 5;
  @media only screen and (max-width: ${size.md}) {
    &:checked + ${MainMenu} {
      display: flex;
      min-height: calc(100vh - 72px);
      position: fixed;
      top: 80px;
      left: 0px;
      background: white;
      display: flex;
      flex-direction: column;
      width: 100%;
    }
  }
`
